import React, { useState, useCallback, useEffect } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import OurLawInfo from './OurLawInfo';

const PRIMARY = '#c4122f';

interface AddStep2ResponsibleProps extends StepProps {
    users: { value: number; label: string }[];
    currentStepName:String;
        ourLawInfo:any;
    setOurLawInfo:(any)=>void;
}

const AddStep2Responsible = ({
    onNext,
    onBack,
    onCancel,
    currentData,
    isFirstStep,
    users,
    currentStepName,
    ourLawInfo,
    setOurLawInfo
}: AddStep2ResponsibleProps) => {
    const [selected, setSelected] = useState<boolean | null>(currentData.hasResponsible ?? null);
    const [selectedUsers, setSelectedUsers] = useState<{ value: number; label: string }[]>(
        currentData.complianceUsers || []
    );
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

    // Clear users when "No" is selected
    useEffect(() => {
        if (selected === false) {
            setSelectedUsers([]);
        }
    }, [selected]);

    const handleYes = () => {
        setSelected(true);
    };

    const handleNo = () => {
        setSelected(false);
    };

    const handleChange = useCallback((val: TypedFormFieldValue<number> | TypedFormFieldValue<number>[] | undefined) => {
        if (Array.isArray(val)) {
            setSelectedUsers(val as any);
        } else if (val) {
            setSelectedUsers([val] as any);
        } else {
            setSelectedUsers([]);
        }
    }, []);

    const handleNext = () => {
        if (selected !== null) {
            // Clear users if "No" is selected
            const usersToSend = selected === false ? [] : selectedUsers;
            onNext({ hasResponsible: selected, complianceUsers: usersToSend });
        }
    };

    const isNextDisabled = selected === null || (selected === true && selectedUsers.length === 0);

    return (
        <div style={{ width: '100%' }}>

             <div
                style={{
                    display: 'flex',
                    width: '100%',
                    gap: '10px',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'stretch',
                }}
            >
                <div
                    style={{
                        width: isMobile ? '100%' : 'calc(50% - 5px)',
                        flexShrink: 0,
                        padding: paperPadding,
                        backgroundColor: '#f7f0f1',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: "350px"
                    }}
                >
                    {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(5),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({
              id: 'law-portal.evalution.plan.select.type.title',
            })}
          </Typography> */}

                    <Box style={{ maxWidth: '320px', width: '100%' }}>
                        <Grid container spacing={3} justifyContent="flex-start">
                            <Grid
                                item
                                xs={12}
                                style={{ display: 'flex', justifyContent: 'center' }}
                            >
                               <Box style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                        <Button
                            variant={selected === true ? 'contained' : 'outlined'}
                            onClick={handleYes}
                            style={{
                                backgroundColor: selected === true ? PRIMARY : 'transparent',
                                color: selected === true ? 'white' : PRIMARY,
                                borderColor: PRIMARY,
                                fontWeight: 700,
                                minWidth: '120px',
                            }}
                        >
                            {formatMessage({ id: 'form.yes', defaultMessage: 'Yes' })}
                        </Button>
                        <Button
                            variant={selected === false ? 'contained' : 'outlined'}
                            onClick={handleNo}
                            style={{
                                backgroundColor: selected === false ? PRIMARY : 'transparent',
                                color: selected === false ? 'white' : PRIMARY,
                                borderColor: PRIMARY,
                                fontWeight: 700,
                                minWidth: '120px',
                            }}
                        >
                            {formatMessage({ id: 'form.no', defaultMessage: 'No' })}
                        </Button>
                    </Box>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                style={{ display: 'flex', justifyContent: 'center' }}
                            >
                               {selected === true && (
                        <Box style={{ maxWidth: '100%', width: '100%', minWidth: '320px', marginTop: '16px' }}>
                            <SelectField
                                name="complianceUsers"
                                placeholder={formatMessage({
                                    id: 'law-portal.manage.edit-law.complianceUsers',
                                    defaultMessage: 'Responsible Person(s)'
                                })}
                                options={users}
                                isMulti={true}
                                errorTexts={[]}
                                initialState={selectedUsers.length > 0 ? selectedUsers : undefined}
                                onChange={handleChange}
                            />
                        </Box>
                    )} 
                            </Grid>
                        </Grid>
                    </Box>
                </div>

                <OurLawInfo ourLawStepInfo={ourLawInfo} currentStepName={currentStepName} onUpdate={setOurLawInfo} />
            </div>

            

            <Box>
                <StepButtonBar
                    onCancel={onCancel}
                    onBack={onBack}
                    onNext={handleNext}
                    nextLabel="form.next"
                    nextDisabled={isNextDisabled}
                    formatMessage={formatMessage}
                    showBack={!isFirstStep}
                />
            </Box>
        </div>
    );
};

export default AddStep2Responsible;
